<template>
    <main class="surface-0 flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden" role="none">
        <div class="grid justify-content-center p-2 lg:p-0" style="min-width: 80%" role="none">
            <div class="col-12 xl:col-6 mt-2 xl:mt-0" style="border-radius: 56px; padding: 0.3rem; background: linear-gradient(180deg, rgba(70, 150, 160, 0.7) 10%, rgba(70, 150, 160, 0) 30%)" role="none">
                <div class="h-full w-full m-0 py-5 px-4" style="border-radius: 53px; background: linear-gradient(180deg, var(--surface-50) 38.9%, var(--surface-0))" role="none">
                    <div class="grid flex-column align-items-center" role="none">
                        <!-- <img src="/images/Logo_139x158.svg" alt="Bemyvega logo" class="mb-2" style="width: 81px; height: 60px" role="none" /> -->
                        <img src="/images/Logo_148x158N.svg" alt="Bemyvega logo" class="mb-2" style="width: 81px; height: 60px" role="none" />
                        <div class="flex justify-content-center align-items-center border-circle" style="width: 3.2rem; height: 3.2rem" role="none"></div>
                        <h1 class="text-900 font-bold text-4xl lg:text-5xl mb-2">{{ $t("endpoints.access.header") }}</h1>
                        <span class="text-700 text-center">{{ $t("endpoints.access.message") }}</span>
                        <img src="/images/asset-access.svg" alt="Acceso denegado" class="mt-3" :width="300" />
                        <div class="col-12 mt-5 text-center" role="none">
                            <i role="none" aria-hidden="true" class="pi pi-fw pi-arrow-left text-blue-00 mr-2" style="vertical-align: center"></i>
                            <router-link to="/login" class="text-blue-700">{{ $t("endpoints.access.redirect") }}</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    created() {
        document.title = this.$t("accesibility.title.access");
    }
};
</script>
